module.exports = __webpack_public_path__ + "static/media/star1.ce81e1fa.svg";